import StoryMetrics from "../images/StoryMetrics.gif";
import { Link } from "react-router-dom";

import chat from "../images/chat_icon.png";



const Home = () => {
  localStorage.setItem('selectedDS','zomato')
    return (
      <div>
        <header className="App-header">
          <img src={StoryMetrics} className="App-logo" alt="logo" />
        </header> 
         <div>
          <Link to="/chat">
            <img src={chat} className="chat_icon" id="chat-icon" alt="chat" />
          </Link>
        </div>
      </div>
        
    )
}

export default Home;